module.exports = __webpack_public_path__ + "static/media/ZMC.8ac0dbbe.pdf";